import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Star, CheckCircle } from 'lucide-react';

const ProducerCard = ({ producer }) => {
  return (
    <Link
      to={`/produttori/${producer.slug}`}
      className="group bg-white border border-border rounded-xl p-6 flex flex-col items-center text-center hover:border-primary/20 hover:shadow-hover transition-all duration-300"
      data-testid={`producer-card-${producer.id}`}
    >
      {/* Logo */}
      <div className="w-24 h-24 rounded-full overflow-hidden bg-background border-2 border-border group-hover:border-primary/30 transition-colors">
        <img
          src={producer.logo_url || 'https://images.pexels.com/photos/15899638/pexels-photo-15899638.jpeg'}
          alt={producer.name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Name */}
      <h3 className="mt-4 font-heading font-semibold text-lg text-text-primary group-hover:text-primary transition-colors">
        {producer.name}
      </h3>

      {/* Badges */}
      <div className="mt-2 flex items-center gap-2">
        {producer.is_featured && (
          <span className="inline-flex items-center gap-1 bg-secondary/10 text-secondary px-2.5 py-0.5 rounded-full text-xs font-semibold">
            <CheckCircle className="w-3 h-3" />
            Verificato
          </span>
        )}
      </div>

      {/* Description */}
      {producer.description && (
        <p className="mt-3 text-sm text-text-secondary line-clamp-2">
          {producer.description}
        </p>
      )}
    </Link>
  );
};

export default ProducerCard;
